import { Sparkles, Store, Search, Clock, MapPin, Megaphone, ShieldCheck, Globe } from 'lucide-react';
import { SectionPageEditor } from '@/components/admin/SectionPageEditor';
import type { SectionDef } from '@/components/admin/SectionPageEditor';

// The retailer/pharmacy cards themselves are fully dynamic (rxk_retailers
// table + core_partners_public_v, the approved ERP partner list) — out of
// scope here, same as Home's Routine/Articles. Only the static text
// wrapped around that list is editable below. No images on this page.
// common.officialStore/common.verify are skipped (shared site-wide
// strings edited under Settings, not page-specific). The Google Maps
// embed location itself is fixed in code — only its heading/subtitle
// are editable, under Map Section below.
const WHERE_TO_BUY_SECTIONS: SectionDef[] = [
  {
    key: 'hero',
    title: 'Hero',
    icon: Sparkles,
    texts: [
      { key: 'whereToBuy.hero.label', label: 'Eyebrow Label' },
      { key: 'whereToBuy.hero.heading', label: 'Heading' },
      { key: 'whereToBuy.hero.subtitle', label: 'Subtitle' },
    ],
  },
  {
    key: 'onlineStore',
    title: 'Official Online Store Banner',
    icon: Store,
    texts: [
      { key: 'whereToBuy.officialStore', label: 'Heading' },
      { key: 'whereToBuy.shopDirect', label: 'Description' },
      { key: 'whereToBuy.shopNow', label: 'Button' },
    ],
  },
  {
    key: 'searchFilter',
    title: 'Search & Filter Bar',
    icon: Search,
    note: 'The filter option values (area/type names) are fixed in code — only the labels below are editable here.',
    texts: [
      { key: 'whereToBuy.searchPlaceholder', label: 'Search Placeholder' },
      { key: 'whereToBuy.filterArea', label: 'Area Filter Label' },
      { key: 'whereToBuy.filterType', label: 'Type Filter Label' },
      { key: 'whereToBuy.showingResults', label: 'Results Count Text' },
    ],
  },
  {
    key: 'authorizedPartners',
    title: 'Authorized Partners Coming Soon Banner',
    icon: Clock,
    texts: [
      { key: 'whereToBuy.authorizedPartners.heading', label: 'Heading' },
      { key: 'whereToBuy.authorizedPartners.description', label: 'Description' },
      { key: 'whereToBuy.authorizedPartners.button', label: 'Button' },
    ],
  },
  {
    key: 'map',
    title: 'Map Section',
    icon: MapPin,
    note: 'The map itself plots live retailer/partner locations (from Retailers admin and ERP Partners) — only the heading/subtitle below are editable here.',
    texts: [
      { key: 'whereToBuy.map.title', label: 'Heading' },
      { key: 'whereToBuy.map.subtitle', label: 'Subtitle' },
    ],
  },
  {
    key: 'partnerCta',
    title: 'Partner Apply CTA Banner',
    icon: Megaphone,
    texts: [
      { key: 'whereToBuy.partnerApply', label: 'Heading' },
      { key: 'whereToBuy.partnerApplyDesc', label: 'Description' },
      { key: 'whereToBuy.applyNow', label: 'Button' },
    ],
  },
  {
    key: 'trust',
    title: 'Authenticity / Trust Section',
    icon: ShieldCheck,
    texts: [
      { key: 'whereToBuy.authenticityGuaranteed', label: 'Heading' },
      { key: 'whereToBuy.qrVerify', label: 'QR Verify Text' },
      { key: 'whereToBuy.reportCounterfeit', label: 'Report Counterfeit Text' },
      { key: 'whereToBuy.reportLink', label: 'Report Link Text' },
    ],
  },
  {
    key: 'seo',
    title: 'SEO',
    icon: Globe,
    note: 'Shown in Google search results and social media link previews — not visible on the page itself.',
    texts: [
      { key: 'seo.whereToBuy.title', label: 'Meta Title', long: true },
      { key: 'seo.whereToBuy.description', label: 'Meta Description', long: true },
    ],
  },
];

export default function AdminWhereToBuyPage() {
  return <SectionPageEditor pageKey="whereToBuy" title="Where to Buy" sections={WHERE_TO_BUY_SECTIONS} />;
}
